export default "__VITE_ASSET__f921f780__"